import React from "react";

import { TextareaAutosize } from "@mui/material";

const CTextarea = ({ onChange, value, disabled, ...props }) => {
  return (
    <React.Fragment>
      <TextareaAutosize
        value={value}
        onChange={onChange}
        disabled={disabled}
        style={{
          background: "#ffff",
          borderRadius: "4px",
          border: "none",
          width: "100%",
          minHeight: "56px",
          padding: "10px 14px",
          color: "#B2B2B2",
        }}
        {...props}
      />
    </React.Fragment>
  );
};

export default CTextarea;
